import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Apply = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/admissions", { replace: true });
  }, [navigate]);
  return null;
};

export default Apply;



